import PropTypes from 'prop-types';

import FormField from '#globalComponents/Forms/FormField';
import Textarea from '#globalComponents/Forms/Textarea';
import TextInput from '#globalComponents/Forms/TextInput';

import { formatPrice } from '../../../utils/formatters';

function Field({ label, editing, value, onChange, type = 'text', placeholder, textarea, className = '' }) {
	return (
		<FormField label={label} className={className}>
			{editing ? (
				textarea ? (
					<Textarea
						value={value ?? ''}
						onChange={(e) => onChange(e.target.value)}
						placeholder={placeholder}
					/>
				) : (
					<TextInput
						type={type}
						step={type === 'number' ? '0.01' : undefined}
						value={value ?? ''}
						onChange={(e) => onChange(e.target.value)}
						placeholder={placeholder}
					/>
				)
			) : (
				<div className="text-sm text-text py-1.5 min-h-[32px]">
					{type === 'number' && value !== null
						? formatPrice(Number(value))
						: value || <span className="text-bgBase-800">—</span>}
				</div>
			)}
		</FormField>
	);
}

Field.propTypes = {
	label: PropTypes.string.isRequired,
	editing: PropTypes.bool,
	value: PropTypes.any,
	onChange: PropTypes.func,
	type: PropTypes.string,
	placeholder: PropTypes.string,
	textarea: PropTypes.bool,
	className: PropTypes.string,
};

export default Field;
